module.exports = __webpack_public_path__ + "static/media/footer-logo-ar.011315cc.svg";